<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { DROP_LIST_THEMES } from '@/utils/components-configurations/app-droplist'
import { getOwnerAvatar, getOwnerName } from '@/utils/objectives'

import AppAvatar from '@/components/ui/AppAvatar/AppAvatar'

defineOptions({
  name: 'OkrElementOwner'
})

const props = defineProps({
  showAvatarReplacer: {
    type: Boolean
  },

  okrElement: {
    type: Object,
    required: true
  }
})

const { t } = useI18n()

const ownerInfo = computed(() => {
  const name = getOwnerName(props.okrElement)

  const ariaLabel = name
    .split(' ')
    .slice(0, 2)
    .map(name => name[0])
    .join('')

  return {
    name: name || t('objective.no_owner'),
    avatar: getOwnerAvatar(props.okrElement),
    ariaLabel
  }
})
</script>

<template>
  <AppAvatar
    v-tippy="{
      content: ownerInfo.name,
      theme: DROP_LIST_THEMES.COMMON_TOOLTIP_THEMES
    }"
    :avatar-url="ownerInfo.avatar"
    :data-aria-label="ownerInfo.ariaLabel"
    :show-avatar-replacer="showAvatarReplacer"
    no-margins
  />
</template>

<style lang="scss" scoped></style>
